import {
  CancelIcon,
  CopyIcon,
  DeleteDocumentIcon,
  DownloadFileIcon,
  DuplicateIcon,
  MoveToIcon,
  NewDocumentIcon,
  NewfolderIcon,
  ShareIcon,
  TrashCanSolidIcon,
  UndeleteIcon,
  ViewDetailsIcon,
  WarningIcon,
} from 'assets/icons';
import { optionItemStyle } from 'Components/Select/Options';
import { ReactNode } from 'react';

export interface IDropdownActionItem {
  text?: ReactNode;
  onClick?: () => void;
  disabled?: boolean;
  icon?: ReactNode;
  theme?: 'green' | 'gray';
  active?: boolean;
}
export function DropdownActionItem({
  onClick,
  text,
  icon,
  active,
  disabled = false,
  theme,
}: IDropdownActionItem) {
  const GrayTheme = active
    ? 'bg-gray-dark bg-opacity-10'
    : 'hover:bg-gray-dark hover:bg-opacity-5';
  const GreenTheme = optionItemStyle(!!active);

  const colorTheme = theme === 'green' ? GreenTheme : GrayTheme;
  return (
    <button
      disabled={disabled}
      className={`py-3 px-4 disabled:text-gray-700 flex gap-3 items-center text-left font-medium text-base leading-3 text-gray-dark cursor-pointer ${colorTheme}`}
      onClick={onClick}
    >
      {icon}
      {text}
    </button>
  );
}

function Clear(props: IDropdownActionItem) {
  return <DropdownActionItem {...props} icon={<CancelIcon />} text="Clear" />;
}
function Delete(props: IDropdownActionItem) {
  return (
    <DropdownActionItem
      {...props}
      text="Delete"
      icon={<TrashCanSolidIcon className="h-4 w-4 text-red-200" />}
    />
  );
}
function Details(props: IDropdownActionItem) {
  return (
    <DropdownActionItem
      {...props}
      text="View Details"
      icon={<ViewDetailsIcon />}
    />
  );
}

function Download(props: IDropdownActionItem) {
  return (
    <DropdownActionItem
      {...props}
      text="Download"
      icon={<DownloadFileIcon />}
    />
  );
}

function DownloadFolder(props: IDropdownActionItem) {
  return (
    <DropdownActionItem
      {...props}
      text="Download Folder"
      icon={<DownloadFileIcon />}
    />
  );
}

function DownloadFolderItem(props: IDropdownActionItem) {
  return (
    <DropdownActionItem
      {...props}
      text="Download Folder"
      icon={<DownloadFileIcon />}
    />
  );
}

function CorruptedDownload(props: IDropdownActionItem) {
  return (
    <DropdownActionItem
      text={<div className="text-gray-700">Download</div>}
      icon={<WarningIcon className="w-4 h-4 text-gray-700" />}
    />
  );
}

function Share(props: IDropdownActionItem) {
  return <DropdownActionItem {...props} text="Share" icon={<ShareIcon />} />;
}

function NewFolder(props: IDropdownActionItem) {
  return (
    <DropdownActionItem {...props} text="New Folder" icon={<NewfolderIcon />} />
  );
}

function NewDocument(props: IDropdownActionItem) {
  return (
    <DropdownActionItem {...props} text="Add New" icon={<NewDocumentIcon />} />
  );
}

function MoveTo(props: IDropdownActionItem) {
  return <DropdownActionItem {...props} text="Move To" icon={<MoveToIcon />} />;
}

function CopyFolder(props: IDropdownActionItem) {
  return (
    <DropdownActionItem
      {...props}
      text="Copy Folder Sturcture"
      icon={<DuplicateIcon />}
    />
  );
}

function MoveToTrash(props: IDropdownActionItem) {
  return (
    <DropdownActionItem
      {...props}
      text="Move to Trash"
      icon={<DeleteDocumentIcon className="w-5 h-5" />}
    />
  );
}

function Restore(props: IDropdownActionItem) {
  return (
    <DropdownActionItem
      {...props}
      text="Restore"
      icon={<UndeleteIcon className="w-5 h-5" />}
    />
  );
}
export default {
  Default: DropdownActionItem,
  Delete,
  Details,
  Restore,
  Download,
  DownloadFolder: DownloadFolderItem,
  NewDocument,
  CopyFolder,
  Share,
  NewFolder,
  MoveTo,
  CorruptedDownload,
  Clear,
  MoveToTrash,
};
